import React, { FC } from 'react';
import { Skeleton } from '@mui/material';

import { Box, Stack, useMediaSwitch } from 'Modules/ui3';

import { NewsItem } from '../../state/news';
import { ContentBox } from '../ContentBox';
import { NewsTag } from '../NewsTag';


type NewsDetailProps = Pick<NewsItem, 'RenderContent' | 'Tags'>;

const Placeholder: FC = () => (
    <>
        <Skeleton width='100%' />
        <Skeleton width='70%' />
        <br />
        <Skeleton width='100%' />
        <Skeleton width='100%' />
        <br />
        <Skeleton width='80%' />
        <Skeleton width='80%' />
    </>
);

export const NewsDetail: FC<NewsDetailProps> = ({ RenderContent, Tags }) => (
    <ContentBox py={useMediaSwitch(8, 8, 6)} px={useMediaSwitch(8, 6, 4)}>
        <Stack direction='row' spacing={4}>
            {Tags?.map((tag, idx) => (
                <NewsTag key={`${tag}_${idx}`} tag={tag} />
            ))}
        </Stack>
        <Box>
            {RenderContent || <Placeholder />}
        </Box>
    </ContentBox>
);
